import React, { useState } from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';
import Input from './Input';

const Layout = styled.div`
  position: relative;
  width: 100%;
  height: ${toRem(theme.input.height.large)};
`;

const TogglePassword = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${toRem(38.5)};
  height: 100%;
  cursor: pointer;

  svg {
    fill: ${theme.color.neutral[400]};
    transition: fill ${theme.transition.icon};
  }

  &:hover {
    svg {
      fill: ${theme.color.neutral[800]};
    }
  }
`;

const Password: React.FC<any> = (props) => {
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

  return (
    <Layout>
      <TogglePassword aria-label="Toggle password visibility" onClick={() => setPasswordVisible(!passwordVisible)}>
        <Icon icon="Eye" width={16.5} height={16.5} />
      </TogglePassword>

      <Input type={passwordVisible ? 'text' : 'password'} autoComplete="off" placeholder="Password" {...props} />
    </Layout>
  );
};

export default Password;
